import { type FC } from "react";

import { cx } from "@emotion/css";
import { Cell } from "@snapchat/snap-design-system";
import { type ColumnCellProps } from "fixed-data-table-2";

import {
    cell,
    cellFlexStart,
    cellHeader,
    cellHighlighted,
    cellPercent,
    cellValue,
} from "./engagementBreakdownCell.styles";

interface EngagementBreakdownCellProps extends Partial<ColumnCellProps> {
    text: string;
    subtext?: string;
    isFlexStart?: boolean;
    isBold?: boolean;
    isHighlighted?: boolean;
}

export const EngagementBreakdownCell: FC<EngagementBreakdownCellProps> = ({
    text,
    subtext,
    isFlexStart,
    isBold,
    isHighlighted,
    ...props
}) => (
    <Cell {...props} className={cx(isHighlighted && cellHighlighted)}>
        <div className={cx(cell, isFlexStart && cellFlexStart)}>
            <div className={cx(cellValue, isBold && cellHeader)}>{text}</div>
            <div className={cellPercent}>{subtext}</div>
        </div>
    </Cell>
);
